export const MIN_THRESHOLD_SAMPLES = 12;
export const RELATED_PERCENTILE = 0.85;
export const VARIANT_PERCENTILE = 0.97;
export const UNCOVERED_PERCENTILE = 0.2;
export const WEIGHT_AFFINITY_PERCENTILE = 0.75;
export const RELATED_BOUNDS = [0.2, 0.75] as const;
export const VARIANT_BOUNDS = [0.5, 0.95] as const;
export const UNCOVERED_BOUNDS = [0.15, 0.45] as const;
export const WEIGHT_AFFINITY_BOUNDS = [0.25, 0.7] as const;

export function quantile(values: readonly number[], q: number): number {
  if (values.length === 0) return Number.NaN;
  const sorted = [...values].sort((left, right) => left - right);
  const clamped = Math.min(1, Math.max(0, q));
  const index = (sorted.length - 1) * clamped;
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  const lowerValue = sorted[lower];
  const upperValue = sorted[upper];
  if (lowerValue === undefined) return Number.NaN;
  if (upperValue === undefined || lower === upper) return lowerValue;
  return lowerValue * (1 - (index - lower)) + upperValue * (index - lower);
}

export function adaptiveSimilarityThreshold(
  similarities: readonly number[],
  percentile: number,
  fallback: number,
  bounds: readonly [number, number],
): number {
  if (similarities.length < MIN_THRESHOLD_SAMPLES) return fallback;
  const estimated = quantile(similarities, percentile);
  if (!Number.isFinite(estimated)) return fallback;
  return Math.min(bounds[1], Math.max(bounds[0], estimated));
}
